import { runImpactCalculateCo2ForProject } from '@/domain/impact-calculate/actions/run-impact-calculate-co2-for-project.action';
import { getImpactCo2AnswersForCategory } from '@/domain/impact-co2/actions/get-impact-co2-answers-for-category.action';
import { ImpactCo2Answer } from '@/domain/impact-co2/entities/question.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  projectId: number;
  answer: ImpactCo2Answer;
  submitMode: 'create' | 'edit';
  recalculateAfterSubmit?: boolean;
};

export const submitImpactCo2Answer = createAppAsyncThunk(
  'impactCo2/submitImpactCo2Answer',
  async (
    { projectId, answer, submitMode, recalculateAfterSubmit = true }: Params,
    { extra: { impactCo2Gateway, snackbarGateway }, dispatch },
  ) => {
    try {
      await impactCo2Gateway.submitImpactAnswer(projectId, answer, submitMode);
      showSnackbarSuccess(snackbarGateway);
      dispatch(
        getImpactCo2AnswersForCategory({
          projectId,
          category: answer.category,
        }),
      );
      if (recalculateAfterSubmit) {
        dispatch(runImpactCalculateCo2ForProject({ projectId }));
      }
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('SubmitImpactCo2Answer.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('SubmitImpactCo2Answer.Message.error'));
}
